export default function (_axios, _store, _router) {
  // Intercept all ajax requests
  _axios.interceptors.request.use(
    function (config) {
      // Do something before request is sent
      _store.dispatch("appLoading");
      // console.log(config)
      return config;
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error).then((error) => {
        _store.dispatch("stopAppLoading");

        _store.commit("ADD_MESSAGE", error);
      });
    },
  );

  // Intercept all ajax responses
  _axios.interceptors.response.use(
    function (response) {
      // Do something with response data
      _store.dispatch("stopAppLoading");

      return response;
    },
    function (err) {
      _store.dispatch("stopAppLoading");

      // Allow certain requests to handle 500 errors themselves by setting a header
      const skipGlobal500 =
        err &&
        err.config &&
        err.config.headers &&
        err.config.headers["X-Skip-Global-500-Error"] === "true";

      // If there's no HTTP response at all, treat it as a network error
      if (!err.response) {
        const message =
          "Network error, please check your internet connection or try again later";
        _store.dispatch("addErrorMessage", message);
        return Promise.reject(err);
      }

      // Let the caller handle the 500 error (e.g. to show a backend message)
      if (skipGlobal500 && err.response.status === 500) {
        return Promise.reject(err);
      }

      if (err.response.status === 500) {
        const message = "Server error, please try again later";
        _store.dispatch("addMessage", { message, messageClass: "danger" });
        return Promise.reject(err.response);
      }

      if (err.response.status === 401) {
        const url = (err.config && err.config.url) || "";
        // These endpoints handle their own redirect on 401 — skip global logout+redirect
        // to avoid double navigation that remounts Login.vue and triggers duplicate
        // google.accounts.id.initialize() calls
        const callerHandlesRedirect =
          url === "authenticate" ||
          url.endsWith("/authenticate") ||
          url === "jwt-token-check" ||
          url.endsWith("/jwt-token-check");
        if (!callerHandlesRedirect) {
          _store.dispatch("processLogout");
          const path = "/login";
          if (_router.currentRoute.path !== path) _router.push(path);
        }

        return Promise.reject(err.response);
      }

      // For all other HTTP errors, just pass the response through
      return Promise.reject(err.response);
    },
  );
}
